import { render, staticRenderFns } from "./PieChartV2.vue?vue&type=template&id=0b7ed879&scoped=true"
import script from "./PieChartV2.vue?vue&type=script&lang=js"
export * from "./PieChartV2.vue?vue&type=script&lang=js"
import style0 from "./PieChartV2.vue?vue&type=style&index=0&id=0b7ed879&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b7ed879",
  null
  
)

export default component.exports